/* Runs deferred, so jQuery is present by then. */
function SomeonePurchased() {
    if(window.innerWidth > 750 ){
      jQuery('.closeNotify').bind('click',function(){
        jQuery('.product-notification').remove();
      });  
      function toggleSomething() {
        if($('.product-notification').hasClass('active')){
          $('.product-notification').removeClass('active')
        }
        else{     
          var number=$('.data-product').length,
              i = Math.floor(Math.random() * number),         
              images = $('.product-notification .data-product:eq('+i+')').data('image'),
              title = $('.product-notification .data-product:eq('+i+')').data('title'),
              url = $('.product-notification .data-product:eq('+i+')').data('url'),
              local =  $('.product-notification .data-product:eq('+i+')').data('local'),
              times =$('.product-notification .data-product:eq('+i+')').data('time');

          $('.product-notification').addClass('active');
          $('.product-notification .product-image').find('img').attr('src', images );
          $('.product-notification .product-name').text(title).attr('href', url );
          $('.product-notification .product-image').attr('href', url );
          $('.product-notification .time-ago').text(times);
          $('.product-notification .from-ago').text(local);
        }
      }
      var time = $('.product-notification').data('time');
      var timer = setInterval(toggleSomething, time);
      $('.product-notification').hover(function(ev){
        clearInterval(timer);
      }, function(ev){
        timer = setInterval(toggleSomething, time);
      });
    }
  }
  document.addEventListener('DOMContentLoaded', function() {
    SomeonePurchased();
    $(document)
      .on( 'shopify:section:load', SomeonePurchased )
      .on( 'shopify:section:unload', SomeonePurchased);
  });
